import React, { useEffect } from "react"
import { useForm, Controller } from "react-hook-form";
import { ClipLoader } from "react-spinners";
import alertify from "alertifyjs";
import { useSavePlaceOfWorshipMutation } from '../../services/employee.service'


export const PlaceOfWorshipForm = ({ empId, onPrev, onNext, profile, isEditing = false }) => {
    const [saveInfo, { isLoading, data, error }] = useSavePlaceOfWorshipMutation();

    const {
        control,
        reset,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues: {
            place_name: '',
            address: '',
            pastor_priest_name: '',
            contact_phone: '',
            religion: '',
            city: '',
            state: '',
            country: '',
            id: ''
        }
    });

    useEffect(() => {
        if (data && data.success) {
            alertify.success(data.message || "Place of worship saved successfully");
            if (onNext) {
                onNext(data.data);
            }
        }

        if (error) {
            alertify.error(error?.message || "Failed to save place of worship");
        }
    }, [data, error]);

    const save = payload => {
        const formData = {
            ...payload,
            employee_id: empId
        };
        saveInfo({ data: formData, id: empId });
    }

    useEffect(() => {
        // Place of worship is an array, get the first item
        const placeData = profile?.place_of_worship?.[0] || profile?.placeOfWorship;

        if (placeData) {
            reset({
                place_name: placeData.place_name || '',
                address: placeData.address || '',
                pastor_priest_name: placeData.pastor_priest_name || '',
                contact_phone: placeData.contact_phone || '',
                religion: placeData.religion || profile?.religion || '',
                city: placeData.city || '',
                state: placeData.state || '',
                country: placeData.country || '',
                id: placeData.id || ''
            });
        }
    }, [profile, reset]);

    return (
        <form onSubmit={handleSubmit(save)}>
            <div className="contact-input-set">
                <div className="row">
                    <div className="card">
                        <div className="card-body">
                            <h3 className="card-title">Place of Worship Information</h3>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <div className="form-group form-focus focused">
                                        <label className="focus-label">Religion <span className="text-danger">*</span></label>
                                        <Controller
                                            name="religion"
                                            control={control}
                                            rules={{ required: "Religion is required" }}
                                            render={({ field: { value, onChange } }) => (
                                                <input
                                                    className={`form-control ${errors.religion ? 'is-invalid' : ''}`}
                                                    type="text"
                                                    value={value}
                                                    onChange={onChange}
                                                    placeholder="Enter religion"
                                                    autoComplete="off"
                                                />
                                            )}
                                        />
                                        {errors.religion && <div className="invalid-feedback">{errors.religion.message}</div>}
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group form-focus focused">
                                        <label className="focus-label">Place Name <span className="text-danger">*</span></label>
                                        <Controller
                                            name="place_name"
                                            control={control}
                                            rules={{ required: "Place name is required" }}
                                            render={({ field: { value, onChange } }) => (
                                                <input
                                                    className={`form-control ${errors.place_name ? 'is-invalid' : ''}`}
                                                    type="text"
                                                    value={value}
                                                    onChange={onChange}
                                                    placeholder="Enter church/mosque name"
                                                    autoComplete="off"
                                                />
                                            )}
                                        />
                                        {errors.place_name && <div className="invalid-feedback">{errors.place_name.message}</div>}
                                    </div>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <div className="form-group form-focus focused">
                                        <label className="focus-label">Address</label>
                                        <Controller
                                            name="address"
                                            control={control}
                                            render={({ field: { value, onChange } }) => (
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={value}
                                                    onChange={onChange}
                                                    placeholder="Enter address"
                                                    autoComplete="off"
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4 mb-3">
                                    <div className="form-group form-focus focused">
                                        <label className="focus-label">City</label>
                                        <Controller
                                            name="city"
                                            control={control}
                                            render={({ field: { value, onChange } }) => (
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={value}
                                                    onChange={onChange}
                                                    placeholder="Enter city"
                                                    autoComplete="off"
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4 mb-3">
                                    <div className="form-group form-focus focused">
                                        <label className="focus-label">State</label>
                                        <Controller
                                            name="state"
                                            control={control}
                                            render={({ field: { value, onChange } }) => (
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={value}
                                                    onChange={onChange}
                                                    placeholder="Enter state"
                                                    autoComplete="off"
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-4 mb-3">
                                    <div className="form-group form-focus focused">
                                        <label className="focus-label">Country</label>
                                        <Controller
                                            name="country"
                                            control={control}
                                            render={({ field: { value, onChange } }) => (
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={value}
                                                    onChange={onChange}
                                                    placeholder="Enter country"
                                                    autoComplete="off"
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group form-focus focused">
                                        <label className="focus-label">Name of Pastor/Imam <span className="text-danger">*</span></label>
                                        <Controller
                                            name="pastor_priest_name"
                                            control={control}
                                            rules={{ required: "Pastor/Imam name is required" }}
                                            render={({ field: { value, onChange } }) => (
                                                <input
                                                    className={`form-control ${errors.pastor_priest_name ? 'is-invalid' : ''}`}
                                                    type="text"
                                                    value={value}
                                                    onChange={onChange}
                                                    placeholder="Enter name"
                                                    autoComplete="off"
                                                />
                                            )}
                                        />
                                        {errors.pastor_priest_name && <div className="invalid-feedback">{errors.pastor_priest_name.message}</div>}
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group form-focus focused">
                                        <label className="focus-label">Phone Number <span className="text-danger">*</span></label>
                                        <Controller
                                            name="contact_phone"
                                            control={control}
                                            rules={{ required: "Phone number is required" }}
                                            render={({ field: { value, onChange } }) => (
                                                <input
                                                    className={`form-control ${errors.contact_phone ? 'is-invalid' : ''}`}
                                                    type="text"
                                                    value={value}
                                                    onChange={onChange}
                                                    placeholder="Enter phone number"
                                                    autoComplete="off"
                                                />
                                            )}
                                        />
                                        {errors.contact_phone && <div className="invalid-feedback">{errors.contact_phone.message}</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 d-flex justify-content-between form-wizard-button">
                        <button
                            className="button btn-lights reset-btn"
                            type="reset"
                            onClick={reset}
                        >
                            Reset
                        </button>
                        <div className='text-end'>
                            {!isEditing &&
                                <button
                                    className="button btn-lights reset-btn"
                                    type="button"
                                    onClick={() => onPrev && onPrev()}
                                >
                                    Prev
                                </button>
                            }
                            <button
                                className="btn btn-primary wizard-next-btn"
                                type="submit"
                            >
                                {!isLoading ? 'Save' : <ClipLoader color='#ffffff' />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
}
